module.exports = __webpack_public_path__ + "public/img/品牌介绍_CN.ac218d1a.png";